import React from 'react'
import { VEC_ICON_NAME } from '../../../../../components/icons/constants'
import { BUTTON_TYPE } from "../../../../../components/button/constants"
import ConfirmationPopup from '../../../../../components/popup/confirmationpopup/ConfirmationPopup'

const TinMatchPopup = ({
    title = 'Are you sure?',
    bodyText = '',
    iconName = VEC_ICON_NAME.WARNING_ICON,
    isOpen = false,
    confirmationButtonProps = {
        onConfirmationCb: () => { },
        confirmationButtonText: "Submit",
        confirmationButtonStyles: {},
        confirmationButtonType: BUTTON_TYPE.PRIMARY,
    },
    cancelButtonProps = {
        onCancelCb: () => { },
        onCloseCb: () => { },
        cancelButtonText: "Cancel",
        cancelButtonStyles: {},
        cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
    },
    isClose = true,
    style = {},
}) => {
    return (
        <ConfirmationPopup
            title={title}
            bodyText={bodyText}
            iconName={iconName}
            isOpen={isOpen}
            confirmationButtonProps={confirmationButtonProps}
            cancelButtonProps={cancelButtonProps}
            customStyle={style}
            isClose={isClose}
        />
    )
}

export default TinMatchPopup
